import { Cross, Rocket } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import ButtonIcon from "ds/components/ButtonIcon";
import Card from "ds/components/Card";
import IconEmphasized from "ds/components/IconEmphasized";
import Typography from "ds/components/Typography";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";

import { TEST_PILOT_ANNOUNCEMENT_ID } from "./constants";
import useDashboardOverviewColumnDismissedAnnouncements from "./useDismissedAnnouncements";

const DashboardOverviewColumnTestPilot = () => {
  const { dismiss } = useDashboardOverviewColumnDismissedAnnouncements();

  return (
    <Card
      title="Spacelift TestPilot program"
      headerPrefix={<IconEmphasized icon={Rocket} color="yellow" />}
      headerSuffix={
        <ButtonIcon
          icon={Cross}
          variant="ghost"
          onPress={() => dismiss(TEST_PILOT_ANNOUNCEMENT_ID)}
        >
          Dismiss
        </ButtonIcon>
      }
      contentGap="large"
    >
      <Typography tag="p" variant="p-body3">
        Help us tailor Spacelift to your needs by joining our testing program!
      </Typography>
      <Box>
        <LinkButton
          variant="secondary"
          size="medium"
          target="_blank"
          rel="noopener noreferrer"
          href="https://spacelift.io/join-test-pilot-program"
          analyticsPage={AnalyticsPageDashboard.Dashboard}
          analyticsTitle="Dashboard - Test Pilot Clicked"
        >
          Sign up
        </LinkButton>
      </Box>
    </Card>
  );
};

export default DashboardOverviewColumnTestPilot;
